// extracted by mini-css-extract-plugin
module.exports = {"container":"CartsPage_container__33Hxi","tableHeader":"CartsPage_tableHeader__17dX6"};